if (!customElements.get('ss-project-video')) {
  customElements.define('ss-project-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const video = dialog.querySelector('video');
      video.muted = true;
      video.defaultMuted = true;
      video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; });
      this.querySelector('.ss-project-video__thumbnail').addEventListener('click', () => {
        dialog.showModal();
        video.play().catch(() => {});
      });
      dialog.querySelector('.ss-project-dialog__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => video.pause());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    }
    disconnectedCallback() {
      const dialog = this.querySelector('dialog');
      if (dialog?.open) dialog.close();
      this.querySelector('video')?.pause();
    }
  });
}

